import * as React from 'react';
import { TableConfiguration } from '@lifeomic/chroma-react/components/TableModule';
import { ButtonUnstyled } from '@lifeomic/chroma-react/components/ButtonUnstyled';
import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { sharedMessages } from '../sharedIntlLabels';
import { BaseBuildTableData } from './types';
import { Test, TestSet } from '../types';
import { VariantSelection } from './useSelectedVariants';
import { createVariantDataObject } from './utils';
import { getAminoAcidField } from '../utils';

interface VariantSelectionColumnProps extends BaseBuildTableData {
  activeAccount?: string;
  variantSelection: VariantSelection;
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  updateVariantSelection: (VariantSelection) => void;
  disabled: boolean;
  cellClassName: string;
}

type BuildFetchVariantSelectionColumnType = (
  props: VariantSelectionColumnProps,
) => (variantSet?: TestSet, activeSequence?: Test) => TableConfiguration[];

export const buildFetchVariantSelectionColumn: BuildFetchVariantSelectionColumnType =

    ({
      activeAccount,
      formatMessage,
      variantSelection,
      updateVariantSelection,
      disabled,
      cellClassName,
    }) =>
    (variantSet?: TestSet, activeTest?: Test) => {
      const aminoAcidField = getAminoAcidField(activeAccount);
      // copied from tableColumns.tsx to avoid checkbox flakiness
      const clickHandler = (
        e:
          | React.MouseEvent<HTMLInputElement, MouseEvent>
          | React.MouseEvent<HTMLButtonElement, MouseEvent>,
      ) => {
        e.stopPropagation();
        e.currentTarget.blur();
        e.preventDefault();
      };

      // copies the design from tableColumns.tsx
      // TODO provides type to rowData
      const getChangeHandler = (rowData: any) => () => {
        const updatedSelection = variantSelection.copyWithToggled(
          createVariantDataObject(
            rowData,
            aminoAcidField,
            variantSet,
            activeTest,
          ),
        );
        updateVariantSelection(updatedSelection);
      };

      return [
        {
          header: {
            content: () => '',
          },
          cell: {
            content: rowData => (
              <ButtonUnstyled
                className={cellClassName}
                onClick={e => {
                  clickHandler(e);
                  getChangeHandler(rowData)();
                }}
                disabled={disabled}
              >
                <Checkbox
                  label=""
                  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
                  aria-label={formatMessage(sharedMessages.selectVariant)}
                  checked={variantSelection.isSelected(rowData.id)}
                  disabled={disabled}
                />
              </ButtonUnstyled>
            ),
          },
          isSticky: true,
        },
      ];
    };
